/// <amd-module name="typeahead/core/userfeedbacktool/ui/HotelSearchResultsPageFeedbackPrompt" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>
import {abTest} from "typeahead/core/plugins/ExecutionHelper";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {SearchType} from "typeahead/core/userfeedbacktool/data/UserFeedbackDataLogger";
import {UserFeedbackTool} from "typeahead/core/userfeedbacktool/UserFeedbackTool";

const resolveHtml: string = `
    <div class="userFeedbackPrompt_resolve">
        <div class="mod-white-wrapper userFeedbackPromptText">
            <span/>
            <a style="display: inline-block; cursor: pointer; color: rgb(0,101,184);"></a>
        </div>
    </div>
`;

const disambigHtml: string = `
    <div class="userFeedbackPrompt_disambig userFeedbackPromptText" style="
        display: block;
        margin: 12px 0 -12px 24px;
        padding: 9px 18px;
        background: white;
    ">
        <span/>
        <a style="display: inline-block; cursor: pointer; color: rgb(0,101,184);"></a>
    </div>
`;

const css: string = `
    .userFeedbackPrompt_disambig, .userFeedbackPrompt_resolve {display:none;}
    .showUserFeedbackPrompt .userFeedbackPrompt_disambig, .showUserFeedbackPrompt .userFeedbackPrompt_resolve
        { display: block; }
    .showUserFeedbackPrompt .userFeedbackPrompt_resolve {
        margin: auto;
        max-width: 69.17647059em;
        padding-right: .70588235em;
        padding-left: .70588235em;
    }
    .showUserFeedbackPrompt .userFeedbackPrompt_resolve .mod-white-wrapper { padding: 6px 12px 6px 30px;}
    [dir=ltr] .showUserFeedbackPrompt .userFeedbackPrompt_resolve .mod-white-wrapper {text-align: left;}
    [dir=rtl] .showUserFeedbackPrompt .userFeedbackPrompt_resolve .mod-white-wrapper {text-align: right;}

    .showUserFeedbackPrompt .userFeedbackPromptText { font-size: 14px; }
    @media screen and (max-width: 958px) {
        .showUserFeedbackPrompt .userFeedbackPrompt_resolve {
            margin: 6px 12px 0 12px;
            padding: 0;
            text-align: left;
        }
        .showUserFeedbackPrompt .userFeedbackPrompt_resolve .mod-white-wrapper {
            border: none;
            border-radius: 0;
            padding: 6px 12px 6px 12px;
        }
    }
    @media screen and (max-width: 491px) { .showUserFeedbackPrompt .userFeedbackPromptText { font-size: 12px; }}
    @media screen and (min-width: 78.75em) {
        .showUserFeedbackPrompt .userFeedbackPrompt_resolve {
            padding-right: 10.82352941em;
            padding-left: 10.11764706em;
            max-width: 89.41176471em;
        }
        .showUserFeedbackPrompt .userFeedbackPrompt_resolve .mod-white-wrapper { padding: 6px 12px 6px 24px; }
    }
`;

export class HotelSearchResultsPageFeedbackPrompt {
    public static getSingleton() {
        if (!this.instance) {
            this.instance = new HotelSearchResultsPageFeedbackPrompt();
        }
        return this.instance;
    }

    private static instance: HotelSearchResultsPageFeedbackPrompt;

    private static isResolveSearch(): boolean {
        return !TypeaheadUtils.getURLParameter("regionId") && !TypeaheadUtils.getURLParameter("latLong");
    }

    private static hasErrorOnPage(): boolean {
        return $("#errorContainer .alert-message").length > 0;
    }

    private static hideUserFeedbackPrompt(): void {
        $("#searchForm").removeClass("showUserFeedbackPrompt");
    }

    private static showUserFeedbackPrompt(): void {
        $("#searchForm").addClass("showUserFeedbackPrompt");
    }

    private $resolveElement: JQuery;
    private $disambigElement: JQuery;
    private $style: JQuery;

    private constructor() {}

    public show(): void {
        this.reset();
        if (HotelSearchResultsPageFeedbackPrompt.isResolveSearch()) {
            this.$resolveElement = $(resolveHtml);
            this.$disambigElement = $(disambigHtml);
            this.buildStyle();

            HotelSearchResultsPageFeedbackPrompt.showUserFeedbackPrompt();
            this.setFeedbackPromptText();
            if (HotelSearchResultsPageFeedbackPrompt.hasErrorOnPage()) {
                $("#mobileErrorContainer").prepend(this.$disambigElement);
            } else {
                $("#wizard").after(this.$resolveElement);
            }
            this.setFeedbackPromptText();
            this.handleSearchWizardOpen();
        } else {
            HotelSearchResultsPageFeedbackPrompt.hideUserFeedbackPrompt();
        }
    }

    private buildStyle(): void {
        const style = document.createElement("style");
        style.type = "text/css";
        style.innerHTML = css;
        this.$style = $(style);
        $("head").append(this.$style);
    }

    private setFeedbackPromptText(): void {
        let incorrectResolveText = loc.incorrectResolveMessage || "Not looking for {0}?";
        incorrectResolveText = incorrectResolveText.replace("{0}" ,
            ($("#searchWizard .destinationName").text() || $("#searchWizard [name=destination]").val()));
        $(".userFeedbackPromptText > span").html(incorrectResolveText);
        $(".userFeedbackPromptText > a")
            .html(loc.helpImproveResolveMessage || "Help improve our search tool")
            .on("click", () => {
                UserFeedbackTool.getSingleton().render(SearchType.resolve,
                    TypeaheadUtils.getURLParameter("destination"), "HOTELS", abTest.getActiveClientTests());
            });
    }

    private handleSearchWizardOpen(): void {
        uitk.subscribe("wizardView.searchWizardOpened", () => {
            // Hide feedback prompt
            HotelSearchResultsPageFeedbackPrompt.hideUserFeedbackPrompt();
            $("#changeSearchWizard").one("click", () => {
                HotelSearchResultsPageFeedbackPrompt.showUserFeedbackPrompt();
            });
        });
    }

    private reset(): void {
        if (this.$disambigElement) {
            this.$disambigElement.remove();
        }
        if (this.$resolveElement) {
            this.$resolveElement.remove();
        }
        if (this.$style) {
            this.$style.remove();
        }
    }
}
